// extracted by mini-css-extract-plugin
export default {"error":"ValidationMessage_error__H31t+","success":"ValidationMessage_success__aME-F"};